/**
 * El nombre de archivo de una cabecera `Content-Disposition`: `filename*=UTF-8''…` (RFC 5987, conserva acentos
 * y la Ñ de un RFC) y, si no viene, `filename="…"`. `null` sin cabecera o sin nombre.
 *
 * Vive aquí para que la próxima descarga lo use en vez de copiar la expresión regular (F-158); las copias que ya
 * existen en otros servicios no se migran en este cambio.
 */
export function fileNameFromContentDisposition(header: string | null | undefined): string | null {
  if (!header) return null
  const match = /filename\*=UTF-8''([^;]+)/i.exec(header) ?? /filename="?([^";]+)"?/i.exec(header)
  if (!match?.[1]) return null
  try {
    return decodeURIComponent(match[1].trim())
  } catch {
    return match[1].trim()
  }
}
